import {Component} from '@angular/core';
import {GpsPoint} from "../../domain/models";
import {ActivatedRoute} from "@angular/router";
import {FractalService} from "../../services/fractal/fractal.service";
import * as L from 'leaflet';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent {
  gpsTrack: GpsPoint[] = [];
  private map;

  constructor(
    private route: ActivatedRoute,
    private api: FractalService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const deviceId = params['id'];
      this.getDeviceGpsPoints(deviceId);
    });
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  private initMap(): void {
    this.map = L.map('map').setView([55.672930, 37.284517], 13);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(this.map);
  }

  getDeviceGpsPoints(deviceId: string): void {
    this.api.getDeviceTrack(deviceId).subscribe(res => {
      this.gpsTrack = res;
      this.gpsTrack.sort((a, b) => {
        if (a.timestamp > b.timestamp) return 1;
        if (a.timestamp < b.timestamp) return -1;
        return 0;
      });
      this.plotTrackOnMap(this.gpsTrack);
    });
  }

  plotTrackOnMap(points: GpsPoint[]): void {
    const polylineOptions = {
      color: 'blue',
      weight: 6,
      opacity: 0.9,
      smoothFactor: 1,
    };

    const latLngs = points.map(point => [point.latitude, point.longitude]);
    const polyline = L.polyline(latLngs, polylineOptions).addTo(this.map);
    this.map.fitBounds(polyline.getBounds());
  }

  selectPoint(point: GpsPoint): void {
    this.map.setView([point.latitude, point.longitude], 13);
    L.marker([point.latitude, point.longitude]).addTo(this.map);
  }
}
